import styled from "styled-components";
import StyledButton from "./Button.styled";

const MoreReadButton = styled(StyledButton)`
  display: block;
  width: 100px;
  height: 40px;
  font-size: 1.4rem;
  margin: 20px auto;
`;

export default MoreReadButton;
